import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Back that returns to the exact previous screen (route, query, tab) when the student came from inside the app.
 * `location.key` is "default" only for the first entry of a session (page opened directly), so only then the fallback is used.
 */
export function useGoBack(fallback: string): () => void {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHistory = location.key !== "default";
  return useCallback(() => {
    if (hasHistory) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [hasHistory, navigate, fallback]);
}
